import React, { FunctionComponent } from 'react';
import ParentComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';

export const TablePrice: FunctionComponent<TParentComponentProps> = (props) => {
  return <ParentComponent {...props} />;
};

TablePrice.defaultProps = {
  defaultClassName: 'cart-table__price',
  as: 'div',
};

export default TablePrice;
